@if (data) {
  @switch (data.layout) {
    @case (layout.LAYOUT1) {
      <app-content-layout-1 [data]="data.data" />
    }
    @case (layout.LAYOUT2) {
      <app-content-layout-2 [data]="data.data" />
    }
    @case (layout.LAYOUT3) {
      <app-content-layout-3 [data]="data.data" />
    }
    @case (layout.LAYOUT4) {
      <app-content-layout-4 [data]="data.data" />
    }
    @case (layout.LAYOUT5) {
      <app-content-layout-5 [data]="data.data" />
    }
    @case (layout.LAYOUT6) {
      <app-content-layout-6 [data]="data.data" />
    }
    @case (layout.LAYOUT7) {
      <app-content-layout-7 [data]="data.data" />
    }
    @case (layout.LAYOUT8) {
      <app-content-layout-8 [data]="data.data" />
    }
    @case (layout.LAYOUT9) {
      <app-content-layout-9 [data]="data.data" />
    }
    @case (layout.LAYOUT10) {
      <app-content-layout-10 [data]="data.data" />
    }
    @case (layout.LAYOUT11) {
      <app-content-layout-11 [data]="data.data" />
    }
    @case (layout.LAYOUT12) {
      <app-content-layout-12 [data]="data.data" />
    }
    @case (layout.LAYOUT13) {
      <app-content-layout-13 [data]="data.data" />
    }
  }
}
